export default __webpack_public_path__ + "static/media/s0_male.c52ea5ed.wav";